import { jsx as _jsx } from "react/jsx-runtime";
import hexagonUrl from '../../../assets/gems/hexagon.svg?inline';
export function Hexagon({ ...props }) {
    return _jsx("img", { ...props, src: hexagonUrl, alt: 'HexagonImage' });
}
